export default __webpack_public_path__ + "static/vitaliy-kalenichenko-c4e307d729174e3264701e73249c333e.png";